import { Phone, Shield, Lock, Cloud, BarChart3, Award, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { NAV_LINKS, scrollTo } from "@/utils/constants";

const modules = ['Skeletal Growth', 'Development Tracking', 'Nutrition', 'Cognitive Assessment', 'Dental Screening'];

const badges = [
  { icon: Shield, label: 'Clinically Validated' },
  { icon: Lock, label: 'Data Secured' },
  { icon: Cloud, label: 'Cloud Platform' },
  { icon: BarChart3, label: 'Instant Reports' },
  { icon: Award, label: 'Expert Backend' },
];

const socialLinks = [
  {
    name: "WhatsApp",
    url: "https://wa.me/918985709090",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    )
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61568978940652",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    )
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/tots360_26/",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    )
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/revanddevchildrenclinic/",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    )
  }
];

const Footer = () => {
  return (
    <footer className="relative bg-[#0F1C3F]" data-testid="footer">
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
      }} />

      {/* Statement Block */}
      <div className="relative py-24 md:py-32 lg:py-40 border-b border-white/5">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[120px] text-white leading-[0.95] tracking-[-0.02em] mb-8">
            Know Your Child.
            <br />
            <span className="text-white/90">Completely.</span>
          </h2>
          <p className="text-[#4ECDC4] text-lg md:text-xl lg:text-2xl font-medium tracking-wide">
            tots360 — AI-Powered Child Health Intelligence
          </p>
        </div>
      </div>

      {/* Logo + Links */}
      <div className="relative py-16 border-b border-white/5">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col items-center mb-12">
            <img 
              src="/logo-cropped.png" 
              alt="tots360 - AI-Powered Child Care by Rev & Dev Children Clinic"
              className="h-16 md:h-24 w-auto object-contain"
              style={{ mixBlendMode: 'screen', filter: 'brightness(1.4)' }}
              data-testid="footer-logo"
            />
          </div>

          <nav className="flex flex-wrap justify-center gap-2 md:gap-8 mb-8">
            {NAV_LINKS.map((link, i) => (
              <a key={i} href={`#${link.id}`} className="text-white/50 hover:text-white text-sm md:text-base transition-colors px-2 py-1">
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex flex-wrap justify-center gap-x-3 gap-y-2 mb-10">
            {modules.map((module, i) => (
              <span key={i} className="flex items-center text-white/30 text-xs md:text-sm">
                {module}
                {i < modules.length - 1 && <span className="ml-3 text-white/10">&middot;</span>}
              </span>
            ))}
          </div>

          {/* Social Media Icons */}
          <div className="flex justify-center gap-4" data-testid="social-links">
            {socialLinks.map((social, i) => (
              <a
                key={i}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-white/40 hover:text-white hover:bg-white/10 hover:border-white/20 transition-all"
                aria-label={social.name}
                data-testid={`social-${social.name.toLowerCase()}`}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="relative py-10 border-b border-white/5">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-0">
            {badges.map((badge, i) => (
              <div key={i} className="flex items-center">
                <div className="flex items-center gap-2 px-4 md:px-6 py-2">
                  <badge.icon className="w-4 h-4 text-white/30" />
                  <span className="text-white/50 text-xs md:text-sm font-medium">{badge.label}</span>
                </div>
                {i < badges.length - 1 && <div className="hidden md:block h-4 w-px bg-white/10" />}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contact Strip */}
      <div className="relative py-12 md:py-16 border-b border-white/5">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 sm:gap-12 mb-6">
            <a href="tel:8985709090" className="flex items-center gap-3 group">
              <div className="w-10 h-10 bg-white/5 rounded-xl flex items-center justify-center group-hover:bg-[#4ECDC4]/20 transition-colors">
                <Phone className="w-5 h-5 text-[#4ECDC4]" />
              </div>
              <span className="text-white text-xl md:text-2xl font-semibold tracking-wide">8985709090</span>
            </a>
            <a href="tel:8985709595" className="flex items-center gap-3 group">
              <div className="w-10 h-10 bg-white/5 rounded-xl flex items-center justify-center group-hover:bg-[#4ECDC4]/20 transition-colors">
                <Phone className="w-5 h-5 text-[#4ECDC4]" />
              </div>
              <span className="text-white text-xl md:text-2xl font-semibold tracking-wide">8985709595</span>
            </a>
          </div>

          <p className="text-white/40 text-sm mb-3">
            Rev &amp; Dev Children Clinic — Screening Enquiries Welcome
          </p>
          <p className="text-white/30 text-xs md:text-sm mb-8 max-w-xl mx-auto" data-testid="footer-seo-line">
            Looking for the <span className="text-white/55">best pediatrician near me</span> in Hyderabad? Visit Rev &amp; Dev Children Clinic, Sanath Nagar — for AI health screening, bone age test and complete child development care.
          </p>

          <button 
            onClick={() => scrollTo('contact')}
            className="inline-flex items-center gap-2 bg-[#4ECDC4] hover:bg-[#44b8b0] text-[#0F1C3F] px-8 py-4 rounded-full font-semibold text-lg transition-all hover:-translate-y-0.5 shadow-lg shadow-[#4ECDC4]/20"
          >
            Book a Screening
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="relative py-6">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/30 text-xs md:text-sm order-2 md:order-1">
              &copy; 2025 Rev & Dev Children Clinic. All rights reserved.
            </p>
            <span className="text-white/20 text-xs font-medium tracking-widest uppercase order-1 md:order-2">
              tots360
            </span>
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 order-3" data-testid="footer-legal-links">
              <Link to="/privacy-policy" className="text-white/30 hover:text-white/70 text-xs md:text-sm transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
              <span className="text-white/10">&middot;</span>
              <Link to="/terms" className="text-white/30 hover:text-white/70 text-xs md:text-sm transition-colors" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
              <span className="text-white/10">&middot;</span>
              <Link to="/refund-policy" className="text-white/30 hover:text-white/70 text-xs md:text-sm transition-colors" data-testid="footer-refund-link">Refund Policy</Link>
              <span className="text-white/10">&middot;</span>
              <Link to="/shipping-policy" className="text-white/30 hover:text-white/70 text-xs md:text-sm transition-colors" data-testid="footer-shipping-link">Service Delivery</Link>
              <span className="text-white/10">&middot;</span>
              <Link to="/developers" className="text-white/30 hover:text-white/70 text-xs md:text-sm transition-colors" data-testid="footer-developers-link">API for Partners</Link>
              <span className="text-white/10">&middot;</span>
              <Link to="/parent-quiz" className="text-white/30 hover:text-white/70 text-xs md:text-sm transition-colors" data-testid="footer-parent-quiz-link">Free Parent Quiz</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
